module.exports = __webpack_public_path__ + "img/logo_f(x)core.bf6a876b.png";